var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { zodResolver } from "@hookform/resolvers/zod";
import { Controller, FormProvider, useForm, } from "react-hook-form";
import { z } from "zod";
import { Combobox, HelperText, Stepper, useStepper } from "@opala-ds/react";
import { useIsMobile } from "../../../hooks/useIsMobile";
import { CollectiveModalities } from "../../../utils/constraints/Modalitys";
import FormActions from "../FormActions";
var Schema = z.object({
    modalidade: z
        .string({ required_error: "Campo obrigatório" })
        .min(1, "Campo obrigatório"),
});
export default function ModalityDataForm(_a) {
    var _this = this;
    var _b;
    var onSubmit = _a.onSubmit;
    var _c = useForm({
        resolver: zodResolver(Schema),
    }), watch = _c.watch, handleSubmit = _c.handleSubmit, register = _c.register, _d = _c.formState, errors = _d.errors, formStateRest = __rest(_d, ["errors"]), formRest = __rest(_c, ["watch", "handleSubmit", "register", "formState"]);
    var nextStep = useStepper().nextStep;
    var isMobile = useIsMobile();
    return (_jsx(FormProvider, __assign({ handleSubmit: handleSubmit, register: register, watch: watch, formState: __assign({ errors: errors }, formStateRest) }, formRest, { children: _jsxs("form", __assign({ className: "w-full flex flex-col space-y-12", onSubmit: handleSubmit(function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            console.log(data);
                            return [4 /*yield*/, onSubmit(data)];
                        case 1:
                            _a.sent();
                            nextStep();
                            return [2 /*return*/];
                    }
                });
            }); }) }, { children: [_jsxs("div", __assign({ className: "flex flex-col space-y-8 py-8" }, { children: [isMobile && (_jsx("div", __assign({ className: "flex justify-start" }, { children: _jsx(Stepper.Radial, { size: 70, weight: 5 }) }))), _jsxs("div", __assign({ className: "flex flex-col space-y-1" }, { children: [_jsx(Controller, { control: formRest.control, name: "modalidade", render: function (_a) {
                                        var _b = _a.field, onChange = _b.onChange, value = _b.value;
                                        return (_jsx(Combobox, { label: "Modalidade", placeholder: "Selecione", containerClassName: "[&>button>div]:text-[#262626]", items: CollectiveModalities.map(function (modalidade) { return ({
                                                label: modalidade,
                                                value: modalidade,
                                            }); }), value: value, onSelectValue: onChange }));
                                    } }), ((_b = errors.modalidade) === null || _b === void 0 ? void 0 : _b.message) && (_jsx(HelperText, { className: "text-red-700", helperText: errors.modalidade.message }))] }))] })), _jsx(FormActions, {})] })) })));
}
